import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/ReportTemplate'
import { SelectReportTemplateCategoryDialog } from './dialog'

class SelectReportTemplateCategoryDialogShell extends React.Component {
  componentDidMount () {
    this.props.get(this.props.id)
  }
  render () {
    const { dialogKey, reportTemplate, closeDialog, reportTemplateLoading, reportTemplateUpdating, title } = this.props
    return (
      <SelectReportTemplateCategoryDialog
        title={title}
        key={dialogKey}
        reportTemplate={reportTemplate}
        loading={reportTemplateLoading}
        updating={reportTemplateUpdating}
        closeDialog={closeDialog}
        onAction={dto => {
          this.props.save(dto, () => this.props.closeDialog())
        }}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    ...state.reportTemplate
  }
}

const mapDispatchToProps = {
  get: actionCreators.getReportTemplate,
  save: actionCreators.updateReportTemplate
}

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(SelectReportTemplateCategoryDialogShell)
}



// WEBPACK FOOTER //
// ./src/dialogs/selectReportTemplateCategory/index.js